// Forma de pagamento "Cartão físico" (D-0116, Rafael 26/10).
//
// O operador está com o cartão da empresa na mão e vai às lojas. Na Previsão só há uma
// ESTIMATIVA (o fornecedor pode ficar "a definir"); o Financeiro aprova a estimativa.
// Depois das compras, o operador define o fornecedor na linha do orçamento e, no Efetivo,
// informa o cartão usado, o valor real e a NF anexada. A conta chega a Contas Pendentes
// já paga na loja: o Financeiro só confere e dá a baixa. Não passa pelo OTP do crédito.
//
// Espelho de app/Services/Financeiro/CartaoFisico.php (a API é a camada que decide).

import { nfParcelaDe } from '../../components/Financeiro/nfParcelasPolicy';

export const FORMA_CARTAO_FISICO = 'cartao_fisico';

export const MSG_PREVISAO_CARTAO_FISICO = 'Cartão físico: lance a estimativa do que vai gastar no cartão da empresa. '
    + 'O fornecedor pode ficar "a definir". Depois das compras, defina o fornecedor na linha do orçamento '
    + 'e informe no Efetivo o cartão usado, o valor real e a NF.';

export const MSG_AGUARDANDO_COMPRAS = 'Estimativa aprovada para o cartão físico. Aguardando o operador voltar das compras e informar, no Efetivo, o cartão usado, o valor real e a NF.';

export const MSG_SO_BAIXA = 'Cartão físico: o operador já pagou na loja com o cartão da empresa. Confira o valor e a NF e dê a baixa.';

export const ehCartaoFisico = (forma) => String(forma || '') === FORMA_CARTAO_FISICO;

// "1.234,56" | "1234.56" | 1234.56 → 1234.56 (0 quando vazio/inválido)
export const parseValor = (raw) => {
    if (raw === null || raw === undefined) return 0;
    let s = String(raw).trim();
    if (s === '') return 0;
    if (s.indexOf(',') !== -1) s = s.replace(/\./g, '').replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0;
};

export const valorReal = (dados) => parseValor(dados && dados.valor_real);

export const acimaDaEstimativa = (real, estimativa) =>
    Math.round((parseFloat(real) || 0) * 100) > Math.round((parseFloat(estimativa) || 0) * 100);

// NF anexada à parcela, pelo mesmo critério da API: com NF por parcela (D-0099) vale a cobertura da
// parcela; sem as tabelas, qualquer NF do fornecedor no orçamento.
export const nfAnexada = (forn, parcela) => {
    if (forn && forn.nf_por_parcela) {
        const np = nfParcelaDe(forn.nf_parcelas, parcela);
        return !!np && !np.pendente;
    }
    return ((forn && forn.nfs) || []).length > 0;
};

// O que falta no Efetivo de uma parcela de cartão físico (rótulos iguais aos da API).
export const faltantesCartaoFisico = (forn, parcela) => {
    const dados = (parcela && parcela.dados_pagamento) || {};
    const faltam = [];
    if (!String(dados.caixa_id || '').trim()) faltam.push('Cartão usado');
    if (valorReal(dados) <= 0) faltam.push('Valor real da compra');
    if (!nfAnexada(forn, parcela)) faltam.push('a NF da compra anexada (aba Documento Fiscal)');
    return faltam;
};

// Pendências de todas as parcelas de cartão físico do card ("Parcela 01: falta ...").
export const pendenciasCartaoFisico = (forn, parcelas, numero) =>
    (parcelas || []).reduce((acc, p, idx) => {
        if (!ehCartaoFisico(p.forma)) return acc;
        const faltam = faltantesCartaoFisico(forn, p);
        if (faltam.length) acc.push('Parcela ' + (numero ? numero(p, idx) : String(idx + 1)) + ' (Cartão físico): falta ' + faltam.join(', '));
        return acc;
    }, []);

// Linha do Custo Previsto / card da Previsão: plano com parcela de cartão físico ainda sem o valor real.
export const aguardandoCompras = (parcelas) =>
    (parcelas || []).some((p) => ehCartaoFisico(p.forma) && valorReal(p.dados_pagamento) <= 0);

// Parcelas de cartão físico com valor real acima da estimativa aprovada (só aviso).
export const parcelasAcimaDaEstimativa = (parcelas) =>
    (parcelas || []).filter((p) => ehCartaoFisico(p.forma)
        && valorReal(p.dados_pagamento) > 0
        && acimaDaEstimativa(valorReal(p.dados_pagamento), p.valor));
